export function redirectTarget(query) {
  const target = query?.redirect;
  if (typeof target !== "string" || !target.startsWith("/") || target.startsWith("//") || target.startsWith("/login")) {
    return null;
  }
  return target;
}
